import React from "react";

import type { CatalogCategory } from "../../model/CatalogCategory";

interface FilterCategoriesProps {
  categories: CatalogCategory[];
  selectedFilter: string[];
  setSelectedFilter: (
    filter: string,
    value: string[] | string,
    brand: string | null,
  ) => void;
}

const FilterCategories: React.FC<FilterCategoriesProps> = ({
  categories,
  selectedFilter,
  setSelectedFilter,
}) => {
  const handleCategoryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    let updatedFilters = [...selectedFilter];

    if (checked) {
      updatedFilters.push(value);
    } else {
      updatedFilters = updatedFilters.filter((filter) => filter !== value);
    }

    setSelectedFilter("categories", updatedFilters, null);
  };

  return (
    <div className="filter-categories field mt-4">
      <div className="control">
        <div className="is-fullwidth flex flex-wrap">
          <div className="is-align-content-space-evenly">
            <label className="label">Categoria</label>
          </div>
          <div className={`filters-container m-4 w-full sm:max-w-[350px]`}>
            {(() => {
              const visible = categories.filter(
                (category) => category.is_filterable,
              );
              const byParent = new Map<string, CatalogCategory[]>();
              for (const category of visible) {
                const parent = category.parent_slug || "";
                const children = byParent.get(parent) ?? [];
                children.push(category);
                byParent.set(parent, children);
              }
              const roots = visible.filter(
                (category) =>
                  !category.parent_slug ||
                  !visible.some(
                    (candidate) => candidate.slug === category.parent_slug,
                  ),
              );
              const renderCategory = (
                category: CatalogCategory,
                depth: number,
              ): React.ReactNode => (
                <div
                  key={category.slug}
                  className="filter-category"
                  style={{ marginLeft: depth * 14 }}
                >
                  <input
                    type="checkbox"
                    id={category.slug}
                    name={category.slug}
                    value={category.slug}
                    className="mr-2"
                    checked={selectedFilter.includes(category.slug)}
                    onChange={handleCategoryChange}
                  />
                  <label htmlFor={category.slug}>{category.name}</label>
                  {(byParent.get(category.slug) ?? []).map((child) =>
                    renderCategory(child, depth + 1),
                  )}
                </div>
              );
              return roots.map((category) => renderCategory(category, 0));
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterCategories;
